import axios from "axios";
import store from "./store";
import Cookies from "js-cookie";
import { clearSession } from "./store/sessionSlice";

const axiosInsatnace = axios.create({
    baseURL: "https://console.indmatrimony.in/api/v2/",
    timeout: 50000,
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: true,
});
// baseURL: "http://127.0.0.1:8000/api/v2/",
// baseURL: "https://api.inddevelopment.in/api/v2/",
// baseURL: "https://payyon.in/api/",axiosInstance
// baseURL: "https://uat-api.inddevelopment.in/api/v2/",
// baseURL: "https://console.indmatrimony.in/api/v2/",

axiosInsatnace.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        const excludedRoutes = ['login', 'basicdetailsform'];
        if (token) {
            // config.headers.Authorization = `Bearer ${token}`;

            if (!excludedRoutes.some(route => config.url.includes(route))) {
                if (config.data && typeof config.data === 'object') {
                    config.data.token = token; // Add token to existing body
                } else {
                    config.data = { token }; // Create request body with token if none exists
                }
            }
        }
        const xsrfToken = Cookies.get("XSRF-TOKEN"); // Correct usage
        if (xsrfToken) {
            config.headers["X-XSRF-TOKEN"] = xsrfToken;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);
// Response Interceptor
axiosInsatnace.interceptors.response.use(
    (response) => response, // ✅ Return successful responses normally
    (error) => {
        if (error.response) {
            console.log("error", error);

            const { data, status } = error.response;

            // ✅ Handle invalid token errors correctly
            if (status === 401 && (data?.message === 'Invalid token' || data?.message === 'invalid signature' || data?.error === 'Unauthorized access' || data?.error === 'Invalid token')) {
                store.dispatch(clearSession()); // Clear session in Redux
                localStorage.clear(); // Clear local storage
                window.location.href = '/login'; // Redirect to login
                localStorage.removeItem('token');
                localStorage.removeItem('user');
            }
        }
        return Promise.reject(error); // Propagate the error
    }
);
axiosInsatnace.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('user'); // or any user info stored
            window.location.href = '/login'; // Or use `navigate()` in React Router
        }
        return Promise.reject(error);
    }
);
export const doLogin = async (data) => {
    try {
        const response = await axiosInsatnace.post('login', data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const doSignUp = async (data) => {
    try {
        const response = await axiosInsatnace.post('basicdetailsform', data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getAllDashboardData = async (data) => {
    try {
        const response = await axiosInsatnace.post('get_all_dashboard_data', data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const addProfessionalDetails = async (data) => {
    try {
        const response = await axiosInsatnace.post('ProfessionalDetails', data
        );
        return response;
    } catch (error) {
        throw error;
    }
}

export const addContactReligionDetails = async (data) => {
    try {
        const response = await axiosInsatnace.post('ContactReligionDetails', data);
        return response;
    } catch (error) {
        throw error;
    }
}
export const submitLifeStyleFamily = async (data) => {
    try {
        const response = await axiosInsatnace.post('lifeStyleFamilyDetails', data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const sendOtp = async (data) => {
    try {
        const response = await axiosInsatnace.post('sendRegistrationSMS', data);
        return response;
    } catch (error) {
        throw error;
    }
}
export const getProfileByList = async () => {
    try {
        const response = await axiosInsatnace.get('profilebylist')
        return response;
    } catch (error) {
        throw error;
    }
}

export const getMaritualStatus = async () => {
    try {
        const response = await axiosInsatnace.get('maritialstatus');
        return response;
    } catch (error) {
        throw error;
    }
};

export const getHeight = async () => {
    try {
        const response = await axiosInsatnace.get('getheight');
        return response;
    } catch (error) {
        throw error;
    }
}
export const getCountry = async () => {
    try {
        const response = await axiosInsatnace.get('GetAllCountries');
        return response;
    } catch (error) {
        throw error;
    }
}

export const getState = async (country_id) => {
    try {
        const response = await axiosInsatnace.post('GetState', { country_id });
        return response;
    } catch (error) {
        throw error;
    }
}

export const getCity = async (State_id) => {
    try {
        const response = await axiosInsatnace.post('GetCity', { State_id });
        return response;
    } catch (error) {
        throw error;
    }
}

export const getEducation = async () => {
    try {
        const response = await axiosInsatnace.post('GetEducation');
        return response;
    } catch (error) {
        throw error;
    }
}

export const getOccupation = async () => {
    try {
        const response = await axiosInsatnace.post('Getoccupation');
        return response;
    } catch (error) {
        throw error;
    }
}
export const getDomain = async () => {
    try {
        const response = await axiosInsatnace.get('GetAllDomain');
        return response;
    } catch (error) {
        throw error;
    }
}
export const getReligion = async (Domain_id) => {
    try {
        const response = await axiosInsatnace.post('GetReligion', { Domain_id });
        return response;
    } catch (error) {
        throw error;
    }
}

export const getAllReligion = async () => {
    try {
        const response = await axiosInsatnace.get('api_get_all_religions');
        return response;
    } catch (error) {
        throw error;
    }
}
export const getCast = async (religion_id) => {
    try {
        const response = await axiosInsatnace.post('GetCast', { religion_id });
        return response;
    } catch (error) {
        throw error;
    }
}

export const getProfileById = async (username) => {
    try {
        const response = await axiosInsatnace.post('searchDataByuserid', username);
        return response;
    } catch (error) {
        throw error;
    }
}
export const getSearch = async (selectedCriteria) => {
    try {
        const response = await axiosInsatnace.post('search', selectedCriteria);
        return response;
    } catch (error) {
        throw error;
    }
}
export const getAllIncome = async () => {
    try {
        const response = await axiosInsatnace.get('getincome');
        return response;
    } catch (error) {
        throw error;
    }
}
export const getMotherTongue = async () => {
    try {
        const response = await axiosInsatnace.get('GetMotherTongue');
        return response
    } catch (error) {
        throw error;
    }
}
export const getFullProfileData = async () => {
    try {
        const response = await axiosInsatnace.post('GetFullProfile');
        return response
    } catch (error) {
        throw error;
    }
}

export const editBasicDetailData = async (data) => {
    try {
        const response = await axiosInsatnace.post('EditBasicDetails', data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getBloodGroup = async () => {
    try {
        const response = await axiosInsatnace.get('bloodgroup');
        return response;
    } catch (error) {
        throw error;
    }
}

export const editProfessionalDetailData = async (data) => {
    try {
        const response = await axiosInsatnace.post('EditProfessionalDetails', data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const editContactDetails = async (data) => {
    try {
        const response = await axiosInsatnace.post('EditContactDetails', data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const editLifeStyleDetails = async (data) => {
    try {
        const response = await axiosInsatnace.post('EditLifestyleAppearance', data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const editReligiousSocialDetails = async (data) => {
    try {
        const response = await axiosInsatnace.post('religious_social_details', data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const editFamilyDetails = async (data) => {
    try {
        const response = await axiosInsatnace.post('Family_details', data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const editPartnerBasicPreference = async (data) => {
    try {
        const response = await axiosInsatnace.post('PartnerBasicPreference', data);
        return response;
    } catch (error) {
        throw error;
    }
}
export const editPartnerprofessionalPreference = async (data) => {
    try {
        const response = await axiosInsatnace.post('EditPartnerprofessionalPreference', data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const editPartnerNativeLocation = async (data) => {
    try {
        const response = await axiosInsatnace.post('editPartnerNativeLocation', data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const editpartnerReligioussocialPreference = async (data) => {
    try {
        const response = await axiosInsatnace.post('EditpartnerReligioussocialPreference', data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const editPartnerLifestyleAppearance = async (data) => {
    try {
        const response = await axiosInsatnace.post('UpdatePartnerLifeStyleAppearance', data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getWeight = async () => {
    try {
        const response = await axiosInsatnace.get('weight');
        return response;
    } catch (error) {
        throw error;
    }
}

export const getAllPhysicalStatus = async () => {
    try {
        const response = await axiosInsatnace.get('physicalstatus');
        return response;
    } catch (error) {
        throw error;
    }
}
export const getAllActivity = async (data) => {
    try {
        const response = await axiosInsatnace.post('activity', data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getCountAllActivity = async (data) => {
    try {
        const response = await axiosInsatnace.post('count_all_activity', data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getPadam = async () => {
    try {
        const response = await axiosInsatnace.get('getpadams');
        return response;
    } catch (error) {
        throw error;
    }
}
export const getstars = async () => {
    try {
        const response = await axiosInsatnace.get('getstars');
        return response;
    } catch (error) {
        throw error;
    }
}
export const getContactUs = async () => {
    try {
        const response = await axiosInsatnace.get('Contactus');
        return response;
    } catch (error) {
        throw error;
    }
}
export const uploadImages = async (formData) => {
    try {
        const response = await axiosInsatnace.post('Photoupload', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response;
    } catch (error) {
        throw error;
    }
};

export const getPhotos = async (data) => {
    try {
        const response = await axiosInsatnace.post('getfullphotos', data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getPhotosById = async (data) => {
    try {
        const response = await axiosInsatnace.post('get-photo-by-id', data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getNotification = async (data) => {
    try {
        const response = await axiosInsatnace.post('allNotifications', data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const changePassword = async (data) => {
    try {
        const response = await axiosInsatnace.post('changepassword', data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const sitePolicy = async () => {
    try {
        const response = await axiosInsatnace.get('site_policy');
        return response;
    } catch (error) {
        throw error;
    }
}

export const getStories = async () => {
    try {
        const response = await axiosInsatnace.get('stories');
        return response;
    } catch (error) {
        throw error;
    }
}

export const getFamilyValue = async () => {
    try {
        const response = await axiosInsatnace.get('family-values');
        return response;
    } catch (error) {
        throw error;
    }
}
export const getFamilyType = async () => {
    try {
        const response = await axiosInsatnace.get('family-type');
        return response;
    } catch (error) {
        throw error;
    }
}
export const getFamilyStatus = async () => {
    try {
        const response = await axiosInsatnace.get('family-status');
        return response;
    } catch (error) {
        throw error;
    }
}
export const getOfficeLocation = async () => {
    try {
        const response = await axiosInsatnace.get('office-location');
        return response;
    } catch (error) {
        throw error;
    }
}

export const getPackageDetails = async () => {

    try {
        const response = await axiosInsatnace.get('ApipackagedetailsNew')
        return response;
    } catch (error) {
        throw error;
    }
}

export const getCustomerCare = async () => {
    try {
        const response = await axiosInsatnace.get('CustomerCare');
        return response;
    } catch (error) {
        throw error;
    }
}

export const getRateUs = async () => {
    try {
        const response = await axiosInsatnace.get('rateUs');
        return response;
    } catch (error) {
        throw error;
    }
}
export const getShareUs = async () => {
    try {
        const response = await axiosInsatnace.get('shareus');
        return response;
    } catch (error) {
        throw error;
    }
}

export const getDeleteReason = async () => {
    try {
        const response = await axiosInsatnace.get('delete_profiles_reason');
        return response;
    } catch (error) {
        throw error;
    }
}

export const deleteProfile = async (data) => {
    try {
        const response = await axiosInsatnace.post('delete_profiles', data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const fetchProfileStatus = async (data) => {
    try {
        const response = await axiosInsatnace.post('hide_profile_status', data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const toggleProfileVisibility = async (data) => {
    try {
        const response = await axiosInsatnace.post('hideProfile', data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const paymentVisit = async (data) => {
    try {
        const response = await axiosInsatnace.post('addPaymentVisit', data);
        return response;
    } catch (error) {
        throw error;
    }
}
export const addPaymentDetails = async (data) => {
    try {
        const response = await axiosInsatnace.post('insertPaymentDetails', data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const sendInterest = async (data) => {
    try {
        const response = await axiosInsatnace.post('send-interest', data);
        return response;
    } catch (error) {
        throw error;
    }
}
export const viewInterestSent = async (data) => {
    try {
        const response = await axiosInsatnace.post('view-interest-sent', data);
        return response;
    } catch (error) {
        throw error;
    }
}
export const viewInterestReceived = async (data) => {
    try {
        const response = await axiosInsatnace.post('view-interest-received', data);
        return response;
    } catch (error) {
        throw error;
    }
}
export const acceptInterest = async (data) => {
    try {
        const response = await axiosInsatnace.post('accept-interest', data);
        return response;
    } catch (error) {
        throw error;
    }
}
export const rejectInterest = async (data) => {
    try {
        const response = await axiosInsatnace.post('reject-interest', data);
        return response;
    } catch (error) {
        throw error;
    }
}
export const profileActivity = async (data) => {
    try {
        const response = await axiosInsatnace.post('profile-activity', data);
        return response;
    } catch (error) {
        throw error;
    }
}
export const getAllHobbies = async () => {
    try {
        const response = await axiosInsatnace.get('get_all_hobbies');
        return response
    } catch (error) {
        throw error;
    }
}

export const editUserHobbies = async (data) => {
    try {
        const response = await axiosInsatnace.post('edit_user_hobbies', data);
        return response;
    } catch (error) {
        throw error;
    }
}
export const editAboutLifePartner = async (data) => {
    try {
        const response = await axiosInsatnace.post('updateAboutMyPartner', data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const saveOrUpdateHabbits = async (payload) => {
    try {
        const response = await axiosInsatnace.post('save-or-update-user-hobbies', { hobbies: payload });
        return response;
    } catch (error) {
        throw error;
    }
}

export const verifyOTP = async (payload) => {
    try {
        const response = await axiosInsatnace.post('verify-otp', payload);
        return response;
    } catch (error) {
        throw error;
    }
}

export const resendOTP = async (data) => {
    try {
        const response = await axiosInsatnace.post('resend-otp', data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const GetMatchesBYType = async (payload) => {
    try {
        const response = await axiosInsatnace.post('GetMatchesBYType', payload
        )
        return response;
    } catch (error) {
        throw error;
    }
}

export const getBanners = async () => {
    try {
        const response = await axiosInsatnace.get('getBanner');
        return response;
    } catch (error) {
        throw error;
    }
}

export const getLoginWithOtp = async (payload) => {
    try {
        const response = await axiosInsatnace.post('login_with_OTP', payload);
        return response;
    } catch (error) {
        throw error;
    }
}

export const verifyLogin = async (payload) => {
    try {
        const response = await axiosInsatnace.post('verify_OTP', payload);
        return response;
    } catch (error) {
        throw error;
    }
}

export const forgetPassword = async (data) => {
    try {
        const response = await axiosInsatnace.post('forgetPassword', data);
        return response;
    } catch (error) {
        throw error;
    }
}
export const verifyOtpAndChangePasswords = async (data) => {
    try {
        const response = await axiosInsatnace.post('verifyOtpAndChangePassword', data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getReligionByIds = async (data) => {
    try {
        const response = await axiosInsatnace.post('getReligionByIds', data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getCasteByIds = async (data) => {
    try {
        const response = await axiosInsatnace.post('getCasteByIds', data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getMultipleState = async (data) => {
    try {
        const response = await axiosInsatnace.post('getMultipleState', data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getMultipleCity = async (data) => {
    try {
        const response = await axiosInsatnace.post('getMultipleCity', data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const setDefaultPhotoApi = async (data) => {
    try {
        const response = await axiosInsatnace.post('setDefaultPhoto', data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const removeImage = async (data) => {
    try {
        const response = await axiosInsatnace.post('removeImage', data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const notificaionCount = async (data) => {
    try {
        const response = await axiosInsatnace.post('notificationCount', data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const readNotification = async (data) => {
    try {
        const response = await axiosInsatnace.post('readStatus', data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const contactView = async (data) => {
    try {
        const response = await axiosInsatnace.post('contactViewStore', data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const activePlans = async (data) => {
    try {
        const response = await axiosInsatnace.post('membershipType', data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const privacySettingShow = async (data) => {
    try {
        const response = await axiosInsatnace.post('privacy-settings-show', data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const privacySetting = async (data) => {
    try {
        const response = await axiosInsatnace.post('privacy-settings', data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const KycService = {
    verifyPan: (data) =>
        axiosInsatnace.post('verify/pan', data),
    requestAdharOtp: (data) =>
        axiosInsatnace.post('verify/aadhar_requestotp', data),
    verifyAdharOtp: (data) =>
        axiosInsatnace.post('verify/aadhar_verifyotp', data),
}

export const kycStatus = async (data) => {
    try {
        const response = await axiosInsatnace.post('kyc_status', data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const chatStatus = async (data) => {
    try {
        const response = await axiosInsatnace.post('start-chat', data);
        return response;
    } catch (error) {
        throw error;
    }
}
export const onlineMatches = async (data) => {
    try {
        const response = await axiosInsatnace.post('onlineList', data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const resetPassword = async (data) => {
    try {
        const response = await axiosInsatnace.post('reset-password', data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const tokenChecker = async (data) => {
    try {
        const response = await axiosInsatnace.post('token-checker', data);
    } catch (error) {

    }
}

export const createRazorpayOrder = async (data) => {
    try {
        const response = await axiosInsatnace.post('create-razorpay-order', data);
        return response;
    }
    catch (error) {
        throw error;
    }
}

export const campaignApi = async (data) => {
    try {
        const response = await axiosInsatnace.post('campaign-form', data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const otp_verification = async (data) => {
    try {
        const response = await axiosInsatnace.post('otp-verification', data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const otp_resent = async (data) => {
    try {
        const response = await axiosInsatnace.post('otp-resend', data);
        return response;
    } catch (error) {
        throw error;
    }
}
export default axiosInsatnace;

